import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SG_TEMPLATES_AUTO_ASSIGN } from 'constants/actions';

export default function AutoAssign() {
  const dispatch = useDispatch();
  const result = useSelector((s) => s.action_template?.autoAssignResult);
  const [payload, setPayload] = useState('');

  function submit(e) {
    e.preventDefault();
    let parsed = {};
    try {
      parsed = JSON.parse(payload);
    } catch (err) {
      alert('Payload must be valid JSON');
      return;
    }
    dispatch({ type: SG_TEMPLATES_AUTO_ASSIGN, payload: parsed });
  }

  return (
    <div>
      <h2>Templates auto assign</h2>
      <form onSubmit={submit}>
        <textarea value={payload} onChange={(e) => setPayload(e.target.value)} rows={8} cols={60} />
        <div>
          <button type="submit">Run</button>
        </div>
      </form>
      <pre>{result ? JSON.stringify(result, null, 2) : 'No result yet'}</pre>
    </div>
  );
}
